/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from "react";

import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

import {
  IconButton,
  Tooltip,
  Divider,
  Backdrop,
  CircularProgress,
  Typography,
} from "@material-ui/core";
import { Edit, Delete, Add, Refresh } from "@material-ui/icons";

import MaterialTable, { MTableToolbar } from "material-table";
import table_icons from "../tableIcons";

import Actions from "../../fluid/Actions/ActionFactory";

import CreateEventGroup from "./components/CreateEventGroup";
import EventList from "./components/EventList";

import { DeleteConfirmationDialog } from "./../Utilities/DeleteConfirmationDialog";
import ErrorMessageAlert from "../Utilities/ErrorMessageAlert";

import SecureWrapper from "../Security/SecureWrapper";
import { allowedByOpop } from "../Security/SecureCheck";

const styles = (theme) => {};

const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    // primary: {
    //     main: "#FF6600",
    //     contrastText: "#FFFFFFFF"
    // },
    secondary: {
      main: "#dc004e",
    },
  },
});

class Events extends Component {
  state = {
    data: [],
    data_loading: false,
    load_event_data: false,
    event_data: null,
    event_data_loading: false,
    event_data_err: false,
    add_group: false,
    deletingItem: {},
    errorOpen: false,
    errorInfo: {},
    confirmDeleteDialogOpen: false,
  };

  componentDidMount = () => {
    this.getTopLevelEvents();
  };

  getTopLevelEvents = () => {
    this.setState(
      {
        ...this.state,
        data_loading: true,
      },
      () => {
        Actions("http_request", {
          url: "/sainapse/event_group/",
          method: "get",
          data: {},
        }).then((res) => {
          let top_level_events = [];

          res.data.result.map((eventGroup) => {
            if (eventGroup.name !== "root") {
              top_level_events.push(eventGroup);
            }
          });

          this.setState(
            {
              ...this.state,
              data: top_level_events,
              data_loading: false,
            },
            () => console.log("Event Groups :", this.state.data)
          );
        });
      }
    );
  };

  closeDialog = (field) => {
    this.setState({ ...this.state, [field]: false }, () =>
      this.getTopLevelEvents()
    );
  };

  getDisableStatus= (name) => {
    
    return !allowedByOpop({
      operation : "/sainapse/event_group/{name}",
      method : "DELETE",
      operands : [
        {
          attrName: "name",
          value : name
    }]
    })
  };

  renderEventGroupActions = (row_data) => {
    if (
      row_data.name !== this.state.deletingItem.name ||
      this.state.confirmDeleteDialogOpen
    ) {
      return (
        <div style={{ display: "flex", flexDirection: "row" }}>
          {/* <Tooltip title = 'Edit'>
                    <IconButton size = "small">
                        <Edit fontSize = "small"/>
                    </IconButton>
                </Tooltip> */}
          <Tooltip title="Delete">
            <IconButton
              size="small"
              color="secondary"
              style={{ color: !this.getDisableStatus(row_data.name) ? "#f44336": "rgb(0,0,0,0.3)", marginRight: "0px" }}
              onClick={() => this.deleteEventGroup(row_data)}
              disabled = {this.getDisableStatus(row_data.name)}
            >
              <Delete fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      );
    } else {
      return <Typography variant="overline">Deleting...</Typography>;
    }
  };

  getEventsByGroupName = (event_group_name) => {
    if (this.state.load_event_data) {
      this.setState(
        {
          ...this.state,
          event_data_loading: true,
        },
        () => {
          Actions("http_request", {
            url: "/sainapse/event_group/" + event_group_name + "/event",
            method: "get",
            data: {},
          })
            .then((res) => {
              this.setState({
                ...this.state,
                event_data: res.data.result,
                event_data_err: false,
                event_data_loading: false,
                load_event_data: false,
              });
            })
            .catch((err) => {
              this.setState({
                ...this.state,
                event_data: null,
                event_data_err: true,
                event_data_loading: false,
                load_event_data: false,
              });
            });
        }
      );
    }
  };

  renderEventsByGroupName = (row_data) => {
    console.log(" Event Grup Data :", row_data);
    return (
      <div style={{ width: "100%", height: "100%", margin: 0, padding: 0 }}>
        <EventList event_group={row_data.name} />
      </div>
    );
  };

  cancelDelete = () => {
    this.setState({ deletingItem: {}, confirmDeleteDialogOpen: false });
  };

  confirmDelete = () => {
    this.setState({ confirmDeleteDialogOpen: false });

    Actions("http_request", {
      url: `/sainapse/event_group/${this.state.deletingItem.name}`,
      method: "delete",
      data: {},
    })
      .then((res) => {
        this.getTopLevelEvents();
        this.setState({ deletingItem: {} });
      })
      .catch((err) =>
        this.setState({
          deletingItem: {},
          errorOpen: true,
          errorInfo: err,
        })
      );
  };

  //delete
  deleteEventGroup = (rowData) => {
    this.setState({ deletingItem: rowData, confirmDeleteDialogOpen: true });
  };

  //error
  handleErrorClose = () => {
    this.setState({ errorOpen: false, errorInfo: {} });
  };

  render() {
    const { classes } = this.props;
    return (
      <Fragment>
        <ThemeProvider theme={blue_theme}>
          <div>
          <SecureWrapper
                                    access_object = {{
                                        operation : "/sainapse/event_group",
                                        method : "GET",
                                        operands : []
                                    }}
                                    shouldRenderErrorMessage = {true}
                                    errorMessage = "User does not have sufficient privileges"
                                    textVariant = "subtitle2"
                                    >
            <MaterialTable
              style={{
                height: "calc(100vh - 50px)",
              }}
              title="Event Groups"
              icons={table_icons}
              data={this.state.data || []}
              columns={[
                {
                  title: "Event Group Name",
                  field: "name",
                  render: (rowData) => (
                    <div style={{ width: "45vw" }}>{rowData.name}</div>
                  ),
                },
                {
                  title: "Created Date",
                  field: "created_date",
                  type: "datetime",
                },
                {
                  title: "Updated Date",
                  field: "updated_date",
                  type: "datetime",
                  defaultSort: "desc",
                },
                {
                  title: "Actions",
                  render: (rowData) => {
                    return this.renderEventGroupActions(rowData);
                  },
                },
              ]}
              detailPanel={(rowData) => this.renderEventsByGroupName(rowData)}
              isLoading={this.state.data_loading}
              options={{
                search: true,
                cellStyle: {
                  height: "20px",
                  margin: "auto",
                },
                toolbarButtonAlignment: "right",
                paging: false,
                headerStyle: {
                  height: "7vh",
                  padding: 0,
                  margin: 0,
                  paddingLeft: "10px",
                  backgroundColor: "#F0F0F0",
                  lineHeight: "1.25",
                },
                maxBodyHeight: "78vh",
                detailPanelType: "multiple",
                draggable: false,
              }}
              components={{
                Toolbar: (props) => (
                  <Fragment>
                    <MTableToolbar {...props} />
                    <Divider />
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row-reverse",
                        height: "5vh",
                        alignContent: "flex-end",
                      }}
                    >
                      <SecureWrapper
                                    access_object = {{
                                        operation : "/sainapse/event_group",
                                        method : "POST",
                                        operands : []
                                    }}
                                    >
                      <Tooltip title="Add Event Group">
                        <IconButton
                          color="primary"
                          onClick={() =>
                            this.setState({ ...this.state, add_group: true })
                          }
                        >
                          <Add />
                        </IconButton>
                      </Tooltip>
                      </SecureWrapper>
                      <SecureWrapper
                                    access_object = {{
                                        operation : "/sainapse/event_group",
                                        method : "GET",
                                        operands : []
                                    }}
                                    >
                      <Tooltip title="Refresh" onClick={this.getTopLevelEvents}>
                        <IconButton color="primary">
                          <Refresh />
                        </IconButton>
                      </Tooltip>
                      </SecureWrapper>
                    </div>
                  </Fragment>
                ),
              }}
            />
            </SecureWrapper>
          </div>
        </ThemeProvider>
        <CreateEventGroup
          zIndex="10"
          open={this.state.add_group}
          close={() => this.closeDialog("add_group")}
        />
        {this.state.errorOpen ? (
          <ErrorMessageAlert
            open={this.state.errorOpen}
            handleClose={this.handleErrorClose}
            errorInfo={this.state.errorInfo}
          ></ErrorMessageAlert>
        ) : null}
        <DeleteConfirmationDialog
          open={this.state.confirmDeleteDialogOpen}
          name={this.state.deletingItem.name}
          type={"Event Group"}
          confirmDeleteHandler={this.confirmDelete}
          cancelDeleteHandler={this.cancelDelete}
        ></DeleteConfirmationDialog>
      </Fragment>
    );
  }
}

export default withStyles(styles)(Events);
